<template>
  <form-layout class="trust-form-layout">
    <span slot="title">委托申请单</span>
    <div class="table_area" slot="main-content">
      <div class="item-box" v-for="(item, index) in tableData">
        <table>
          <thead>
            <tr>
              <td width="260">物料名称</td>
              <td width="130">品项</td>
              <td width="120">品牌</td>
              <td width="120">机型</td>
              <td>模块</td>
              <td>库存</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {{item.ProductName}}<br>
                物料编码：{{item.ProductCode}}
              </td>
              <td>
                <el-tag :type="item.ConditionName | ConditionColor">{{item.ConditionName}}</el-tag>
              </td>
              <td>
                {{item.ProductBrandName}}
              </td>
              <td>
                {{item.ProductModelName}}
              </td>
              <td>
                {{item.ProductModuleName}}
              </td>
              <td>
                {{item.Quantity}}
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <td width="260">委托时长</td>
              <td width="260">数量</td>
              <td width="260">单价</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <el-select class="form-input" v-model="item.trusttime" placeholder="请选择委托时长">
                  <el-option
                    v-for="trust in TrustTimes"
                    :key="trust.label"
                    :label="trust.label"
                    :value="trust.value">
                  </el-option>
                </el-select>
              </td>
              <td >
                <el-input type="number" min="1" placeholder="数量" v-model.number="item.number"></el-input>
              </td>
              <td>
                <el-input type="number" min="1" placeholder="单价" v-model.number="item.price"></el-input>
              </td>
              <td colspan='4' style="display:none;"></td>
            </tr>
          </tbody>
        </table>
        <el-button class="delete-btn" @click.native="deleteItem(index, item)">X</el-button>
      </div>
    </div>
    <div class="sumbit_box" slot="sumbit_box">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules"  :inline="true" style="display:inline;float:left;">
        <el-form-item label="委托类型">
          <el-select class="form-input" v-model="ruleForm.TrustType" placeholder="请选择委托类型">
            <el-option
              v-for="item in TrustTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button @click.native="cancel">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click.native="sumbit">提交并等待客服联系</el-button>
    </div>
  </form-layout>
</template>

<script>
import FormLayout from '@/components/pages/Inventory/TrustFormLayout'
import o from '@/odata'
export default {
  data() {
    return {
      ruleForm: {
        TrustType: '',
      },
      rules: {
        TrustType: [{required: true, message: '必填'}],
      },
      TrustTypes: [
        {label: '可租可售', value: 'rent_sales'},
        {label: '只租', value: 'rent'},
        {label: '只售', value: 'sales'},
        // {label: '代管', value: 'managed'},
      ],
      a: 0,
      TrustTimes: [
        {label: '30天', value: 30},
        {label: '60天', value: 60},
        {label: '90天', value: 90},
        {label: '120天', value: 120},
        {label: '150天', value: 150},
        {label: '180天', value: 180},
        {label: '210天', value: 210},
      ],
      trustbox: [],
      tableData: [],
      sumbitbox: [],
      submitLoading: false,
    }
  },
  methods: {
    sumbit: function() {
//       this.$refs['ruleForm'].validate((valid) => {
//         if (valid) {
//           let loading = Loading.service({text: '加载中'})
//           for (var a = 0; a < this.tableData.length; a++) {
//             this.sumbitbox.push({
//               ProductId: this.tableData[a].ProductId,
//               ConditionId: this.tableData[a].ConditionId,
//               Quantity: this.tableData[a].number,
//               DelegationPeriodDays: this.tableData[a].trusttime,
//               DelegationUnitPrice: this.tableData[a].price,
//             })
//           }
//           const Delegation = o('DelegationRequest')
//           const form = {
//             DelegationType: this.ruleForm.TrustType,
//             Lines: this.sumbitbox,
//           }
//           Delegation.post(form).save().then((response) => {
//             this.$message({
//               message: '提交成功',
//               type: 'success',
//             })
//             loading.close()
//             this.trustbox = []
//             window.localStorage.setItem('trustbox', JSON.stringify(this.trustbox))
//             this.$router.push('/managed')
//           }).catch((response) => {})
//         }
      // 申请的物料可能有多个，但是rule验证规则只能验证一个表单，所以使用下面这种方式
      this.submitLoading = true
      let error = 0
      for (var a = 0; a < this.tableData.length; a++) {
        if (!this.tableData[a].price || !this.tableData[a].trusttime) {
          error = 1
        }
        this.sumbitbox.push({
          ProductId: this.tableData[a].ProductId,
          ConditionId: this.tableData[a].ConditionId,
          Quantity: this.tableData[a].number,
          DelegationPeriodDays: this.tableData[a].trusttime,
          DelegationUnitPrice: this.tableData[a].price,
        })
      }
      // 验证委托时长和价格是否通过
      if (error > 0) {
        this.submitLoading = false
        return this.$message({
          message: '请填写委托时长和价格',
          type: 'warning',
        })
      }
      // 验证委托类型是否填写
      if (!this.ruleForm.TrustType) {
        this.submitLoading = false
        return this.$message({
          message: '请选择委托类型',
          type: 'warning',
        })
      }
      console.log(this.ruleForm.TrustType)
      const Delegation = o('DelegationRequest')
      const form = {
        DelegationType: this.ruleForm.TrustType,
        Lines: this.sumbitbox,
      }
      Delegation.post(form).save().then((response) => {
        this.$message({
          message: '提交成功',
          type: 'success',
        })
        this.submitLoading = false
        this.trustbox = []
        window.localStorage.setItem('trustbox', JSON.stringify(this.trustbox))
        // this.$router.push('/managed')
        this.$router.push('/entrust_order')
      }).catch((response) => {
        this.submitLoading = false
        return this.$message({
          message: '出现异常:' + response.message,
          type: 'error',
        })
      })
    },
    deleteItem: function(index, item) {
      this.$confirm('是否确认删除?', '删除批次', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.trustbox.splice(index, 1)
        window.localStorage.setItem('trustbox', JSON.stringify(this.trustbox))
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
        this.initManaged()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    cancel: function() {
      window.localStorage.setItem('orderUrl', 'entrustOrder')
      this.$router.push('/managed')
    },
    initManaged: function() {
      this.tableData = []
      this.trustbox = JSON.parse(window.localStorage.getItem('trustbox'))
      for (var a = 0; a < this.trustbox.length; a++) {
        this.tableData.push({
          Id: this.trustbox[a].Id,
          ProductCode: this.trustbox[a].ProductCode,
          ProductName: this.trustbox[a].ProductName,
          ConditionName: this.trustbox[a].ConditionName,
          ProductBrandName: this.trustbox[a].ProductBrandName,
          ProductModelName: this.trustbox[a].ProductModelName,
          ProductModuleName: this.trustbox[a].ProductModuleName,
          Quantity: this.trustbox[a].Quantity,
          ProductId: this.trustbox[a].ProductId,
          ConditionId: this.trustbox[a].ConditionId,
          price: null,
          trusttime: null,
          number: 1,
        })
      }
    },
  },
  components: {
    FormLayout,
  },
  created() {
    this.initManaged()
  },
}
</script>

<style lang="less" scoped>
.form-layout .apply-box{
  display: none;
}
.form-input {
  width: 260px;
}
.list-layout .complex-table .sub-row-table .sub-body .text-center{
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}
.main-content{
  .tab{
    .el-tabs__active-bar{
      background-color: rgba(0,0,0,0);
    }
  }
}
.add-btn:hover,.add-btn:focus{
  color: #FFFFFF;
  background: #2283CA;
}
.item-box{
  position: relative;
  padding:10px 20px;
  background-color: #fff;
  margin-bottom: 10px;
  border: 1px solid #E1E8EE;
  width: 90%;
  .el-select,.el-input{
    width: 100%;
  }
  .delete-btn{
    position: absolute;
    right: -60px;
    top: 35%;
    background-color: #FF4949;
    color: #fff;
    padding: 10px 12px;
    border-radius: 50%;
    border: none;
  }
  table{
    display: inline-block;
    label{
      display: block;
      margin-bottom: 5px;
    }
    td{
      padding: 5px 10px 5px 0;
    }
    td:last-child{
      padding-right: 0;
    }
  }
}
.sumbit_box{
  margin-top: 20px;
  text-align: right;
  p{
    text-align: right;
    font-size: 18px;
    color:  #1F2D3D;
    span{
      color: #FF4949;
    }
  }
  .el-button {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// TrustApplyPage.vue?dc0f1d1c